import { render, staticRenderFns } from "./Oauth.vue?vue&type=template&id=f356bdb0&scoped=true"
import script from "./Oauth.vue?vue&type=script&lang=js"
export * from "./Oauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f356bdb0",
  null
  
)

export default component.exports